import { FileTextIcon, PillIcon, RefreshIcon, HeartPulseIcon, StethoscopeIcon } from "../../icons.js";
import type React from "react";
import type { WidgetProps } from "../types.js";

const REPORT_ITEMS: { label: string; Icon: React.ComponentType<{ size?: number; className?: string }> }[] = [
  { label: "Medications taken",        Icon: PillIcon },
  { label: "New / changed meds",       Icon: RefreshIcon },
  { label: "Symptom & med timeline",   Icon: HeartPulseIcon },
  { label: "Pre-visit summary",        Icon: StethoscopeIcon },
];

export function ReportsWidget({ onNavigate }: WidgetProps) {
  return (
    <section className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
      <div className="mb-2 flex items-center gap-2">
        <FileTextIcon size={16} className="text-(--accent)" />
        <h2 className="font-semibold text-gray-900 dark:text-gray-100">Reports</h2>
        <button onClick={() => onNavigate("reports")} className="ml-auto text-xs text-(--accent) hover:underline">
          Open
        </button>
      </div>
      <ul className="space-y-1.5">
        {REPORT_ITEMS.map(({ label, Icon }) => (
          <li key={label}>
            <button
              onClick={() => onNavigate("reports")}
              className="flex w-full items-center gap-2 text-sm text-gray-700 dark:text-gray-300 hover:text-(--accent)"
            >
              <Icon size={14} className="shrink-0 text-gray-400 dark:text-gray-500" />
              <span className="text-left">{label}</span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
